import { useEffect, useState } from "react";
import { motion, useSpring, useMotionValue } from "framer-motion";

export const CustomCursor = () => {
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const rx = useSpring(x, { damping: 30, stiffness: 350, mass: 0.5 });
  const ry = useSpring(y, { damping: 30, stiffness: 350, mass: 0.5 });
  const [hover, setHover] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("cursor-none");
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => setHover(!!(e.target.closest && e.target.closest("a,button,[data-cursor],input,textarea,select")));
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      document.body.classList.remove("cursor-none");
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      {/* precise dot */}
      <motion.div style={{ x, y }} className="pointer-events-none fixed left-0 top-0 z-[999]">
        <div className="h-1.5 w-1.5 -ml-[3px] -mt-[3px] rounded-full" style={{ background: "var(--accent-primary)" }} />
      </motion.div>
      {/* lagging ring */}
      <motion.div style={{ x: rx, y: ry }} className="pointer-events-none fixed left-0 top-0 z-[999]">
        <motion.div
          animate={{ width: hover ? 52 : 30, height: hover ? 52 : 30, opacity: hover ? 1 : 0.6 }}
          transition={{ type: "spring", damping: 20, stiffness: 250 }}
          className="rounded-full border"
          style={{ borderColor: "var(--accent-primary)", marginLeft: hover ? -26 : -15, marginTop: hover ? -26 : -15 }}
        />
      </motion.div>
    </>
  );
};
